export type AccessData = {
  can_read: boolean;
  display_paid_access_block: boolean;
  requires_paid: boolean;
  is_early_access: boolean;
  last_view_id: number | null;
  is_geo_restricted: boolean;
};

export type TrackViewPayload = {
  viewer_mode: string;
  page_id: number;
  double_page_id?: number;
  last_view_id?: number;
  fragment_id?: number;
};

export type ToggleReactionPayload = {
  reaction_type_id: number;
};

export enum NavigationTrigger {
  /// The user clicked on the next release button of the consumption
  nextReleaseButton = "next_release_button",

  /// The user clicked on the previous release button of the consumption
  previousReleaseButton = "previous_release_button",

  /// The user clicked on a card of the releases list of the comic details
  releasesListCard = "releases_list_card",

  /// The user clicked on a card of the related comics list of
  /// the comic details or interstitial
  relatedListCard = "related_list_card",

  /// The user clicked on the start reading button of the comic details
  startReadingButton = "start_reading_button",

  /// The user clicked on the continue reading button of the comic details
  continueReadingButton = "continue_reading_button",

  /// The user clicked on the start next release button of interstitial
  startNextReleaseButton = "start_next_release_button",

  /// The user clicked on the preview release button of the contextual menu
  previewReleaseButtonReleaseContextual = "preview_release_button_release_contextual",

  /// The user clicked on the start reading button of the contextual menu
  startReadingButtonReleaseContextual = "start_reading_button_release_contextual",

  /// The user clicked on the continue reading button of the contextual menu
  continueReadingButtonReleaseContextual = "continue_reading_button_release_contextual",

  /// The user clicks on the preview release button in release details
  previewReleaseButtonReleaseDetails = "preview_release_button_release_details",

  /// The user clicked on the start reading button in release details
  startReadingButtonReleaseDetails = "start_reading_button_release_details",

  /// The user clicked on the continue reading button in release details
  continueReadingButtonReleaseDetails = "continue_reading_button_release_details",

  /// The user clicked on a page thumbnail card in release details
  pageThumbnailCard = "page_thumbnail_card",

  // Web-specific triggers below

  /// The user completed onboarding/congrats flow
  congratsSplashCTAButton = "congrats_splash_cta_button",

  /// The user clicked on a trends comic card
  trendsComicCard = "trends_comic_card",

  /// The user clicked on a search result
  searchResultCard = "search_result_card",

  /// The user clicked on a card from a special landing page (e.g., Valkyrae)
  specialLandingPageCard = "special_landing_page_card",

  /// The user was redirected from a legacy URL to the reader
  readerRedirect = "reader_redirect",

  /// The user closed a paywall and navigated back to the last free page
  paywallClose = "paywall_close",

  /// The user clicked on a hero card (large carousel card)
  heroCardClicked = "hero_card_clicked",

  /// The user clicked on a feature card (medium promoted content card)
  featureCardClicked = "feature_card_clicked",
}

export type ReaderNavigationContext = {
  /// The name of the area where the read comic action took place
  area?: string;

  /// The position of the card where the read comic action took place
  cardPosition?: number;

  /// The identifier of the comic where the app is focussing at the moment
  /// of navigation (For example: The comic identifier of the one loaded
  /// in the comic details)
  comicId?: number;

  /// The notification type id where the read comic action took place
  notificationTypeId?: number;

  /// The position of the related card where the read comic action took
  /// place
  relatedCardPosition?: number;

  /// The search query where the read comic action took place
  q?: string;

  /// The tracked search query identifier where the read comic action took place
  searchQueryId?: string;

  /// The feed where the read comic action took place
  stream?: string;

  /// The section id where the read comic action took place
  sectionId?: number;

  /// The position of the section where the read comic action took place
  sectionPosition?: number;

  /// The type of the section where the read comic action took place
  sectionType?: string;

  /// The trigger where the read comic action took place
  trigger?: NavigationTrigger;

  /// The originating recommendation impression for downstream attribution
  impressionId?: string;

  /// The search result tab where the action took place
  searchTab?: string;
};
